import { useEffect, useState } from "react"
import { getLightLandingLogo } from "@/lib/siteHosts"
import { focusRing } from "../lightTheme"

const headerControl =
  "inline-flex h-8 shrink-0 cursor-pointer select-none items-center justify-center rounded-[6px] px-2 md:px-3 text-[14px] font-medium leading-[21px] transition-colors duration-150"
const headerGhostClass = `${headerControl} bg-white text-[#171717] shadow-[0_0_0_1px_#EBEBEB] hover:bg-[#F2F2F2] ${focusRing}`
const headerSolidClass = `${headerControl} bg-[#171717] text-white hover:bg-[#383838] ${focusRing}`

export default function LightHeader() {
  const logo = getLightLandingLogo()
  const [scrolled, setScrolled] = useState(
    () => typeof window !== "undefined" && window.scrollY > 0
  )

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 0)
    onScroll()
    window.addEventListener("scroll", onScroll)
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  return (
    <header
      className={`sticky top-0 z-50 h-16 w-full ${
        scrolled
          ? "bg-[#FAFAFA] shadow-[0_1px_0_0_rgba(0,0,0,0.08)]"
          : "bg-transparent shadow-none"
      }`}
    >
      <div className="mx-auto flex h-full w-full max-w-[1400px] items-center justify-between gap-3 px-6">
        <button type="button" className="cursor-pointer">
          <img
            src={logo.src}
            alt={logo.alt}
            className="h-[18px] w-auto md:h-6"
          />
        </button>
        <div className="flex items-center gap-3">
          <button type="button" className={headerGhostClass}>
            Get a Demo
          </button>
          <button type="button" className={headerGhostClass}>
            Log In
          </button>
          <button type="button" className={headerSolidClass}>
            Sign Up
          </button>
        </div>
      </div>
    </header>
  )
}
